export const FORM_INPUT_REF_DELAY = 100;
